import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f3aafcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["element-loading-text"]

import { ref, onMounted, reactive, unref } from 'vue';
import { FormRules, ElMessage, ElForm } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useLocales } from '@/hooks/useLocales';
import { useDictionary } from '@/store/dictionary.store';
import { GetMainstaySelectApi } from '@/apis/basics/mainstay.api';
import { GetCompanyDetailApi, CreateCompanyApi, ModifyCompanyApi } from '@/apis/basics/companys/apis';
import { CompanyDtoBase } from '../../../../apis/basics/companys/dtos';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { t } = useLocales();
const { getSelectList } = useDictionary();

const elFormRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	show: false,
	loading: false,
	title: '',
	isAsync: false,
	isEditor: false,
});

const businessStatus = ref<any[]>([]);
const mainstayList = ref<any[]>([]);

const formSchema = ref<CompanyDtoBase>({
	id: '',
	revision: '',
	cmp_code: '',
	cmp_name: '',
	business_code: '',
	short_name: '',
	address: '',
	remark: '',
	is_enabled: '',
	prefix_no: '',
	business_status: '1',
	is_async: 'N',
	sort: 0,
	mainstay_list: [],
});

/* 表单验证规则 */
const formRules: FormRules = {
	cmp_code: [{ required: true, message: t('companys.forms.cmp_code.valitext'), trigger: 'blur' }],
	cmp_name: [{ required: true, message: t('companys.forms.cmp_name.valitext'), trigger: 'blur' }],
	business_code: [{ required: true, message: t('companys.forms.business_code.valitext'), trigger: 'blur' }],
	prefix_no: [{ required: true, message: t('companys.forms.prefix_no.valitext'), trigger: 'blur' }],
	business_status: [{ required: true, message: t('companys.forms.business_status.valitext'), trigger: 'blur' }],
	mainstay_list: [{ required: true, message: t('companys.forms.mainstay_list.valitext'), trigger: 'blur' }],
};

/* 需要处理加载的数据 */
const load = {
	/* 我方主体选择数据 */
	getMainstaySelectList: async () => {
		const { succeeded, errors, data } = await GetMainstaySelectApi('');

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			mainstayList.value = data || [];
		}
	},
};

const expostFuncs = {
	/* 创建 */
	create: () => {
		formSchema.value = Object({
			id: '',
			revision: '0',
			cmp_code: '',
			cmp_name: '',
			business_code: '',
			short_name: '',
			address: '',
			remark: '',
			is_enabled: 'Y',
			prefix_no: '',
			business_status: '1',
			sort: 100,
			mainstay_list: [],
		});

		state.title = t('companys.title.create');
		state.isEditor = false;
		state.show = true;
	},

	/* 修改 */
	editor: async (rowId: string) => {
		state.loading = true;

		const { succeeded, errors, data } = await GetCompanyDetailApi(rowId);

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			formSchema.value = data;

			unref(formSchema).business_status = data.business_status + '';
			state.isAsync = (data.is_async || 'N') == 'N' ? false : true;
		}

		state.title = t('companys.title.editor');
		state.loading = false;
		state.isEditor = true;
		state.show = true;
	},
};

/* 点击保存按钮 */
const onSaveBtnClick = () => {
	unref(elFormRef)?.validate(async (valid: boolean) => {
		if (!valid) return;

		state.loading = true;

		const formData = unref(formSchema);
		const api = !state.isEditor ? CreateCompanyApi : ModifyCompanyApi;
		const { succeeded, errors } = await api(formData);

		state.loading = false;

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			ElMessage.success(t('tips.savesuccess'));
			state.show = false;
		}

		$emits('refresh');
	});
};

expose({ ...expostFuncs });

onMounted(() => {
	load.getMainstaySelectList();
	businessStatus.value = getSelectList('business_status');
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    style: {"width":"720px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: _unref(state).loading,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.closed')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        "element-loading-text": _unref(t)('tips.submiting')
      }, [
        _createVNode(_unref(ElForm), {
          size: "small",
          ref_key: "elFormRef",
          ref: elFormRef,
          "label-width": "100px",
          model: formSchema.value,
          "label-position": 'right',
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.cmp_name.label'),
                      prop: "cmp_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.cmp_name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.cmp_name) = $event)),
                          disabled: _unref(state).isAsync,
                          type: "text",
                          placeholder: _unref(t)('companys.forms.cmp_name.placeholder')
                        }, null, 8, ["modelValue", "disabled", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.cmp_code.label'),
                      prop: "cmp_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.cmp_code,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.cmp_code) = $event)),
                          disabled: _unref(state).isAsync,
                          type: "text",
                          placeholder: _unref(t)('companys.forms.cmp_code.placeholder')
                        }, null, 8, ["modelValue", "disabled", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.business_code.label'),
                      prop: "business_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.business_code,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.business_code) = $event)),
                          disabled: _unref(state).isAsync,
                          type: "text",
                          placeholder: _unref(t)('companys.forms.business_code.placeholder')
                        }, null, 8, ["modelValue", "disabled", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.prefix_no.label'),
                      prop: "prefix_no"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.prefix_no,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.prefix_no) = $event)),
                          disabled: _unref(state).isAsync,
                          type: "text",
                          placeholder: _unref(t)('companys.forms.prefix_no.placeholder')
                        }, null, 8, ["modelValue", "disabled", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.short_name.label')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.short_name,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.short_name) = $event)),
                          disabled: _unref(state).isAsync,
                          type: "text",
                          placeholder: _unref(t)('companys.forms.short_name.placeholder')
                        }, null, 8, ["modelValue", "disabled", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.address.label'),
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.address,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.address) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "150",
                          rows: "3",
                          placeholder: _unref(t)('companys.forms.address.placeholder')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.mainstay_list.label'),
                      prop: "mainstay_list"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          style: {"width":"100%"},
                          modelValue: formSchema.value.mainstay_list,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.mainstay_list) = $event)),
                          filterable: "",
                          "collapse-tags": "",
                          "collapse-tags-tooltip": "",
                          multiple: "",
                          placeholder: _unref(t)('companys.forms.mainstay_list.placeholder')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainstayList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.business_status.label'),
                      prop: "business_status"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.business_status,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.business_status) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessStatus.value, (dic) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: dic.label,
                                value: dic.value
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.sort.label')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formSchema.value.sort,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.sort) = $event)),
                          step: "100",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.remark.label'),
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.remark) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "200",
                          rows: "4",
                          placeholder: _unref(t)('companys.forms.remark.placeholder')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('companys.forms.is_enabled.label')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('status.enabled')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('status.diabled')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ], 8, _hoisted_1)), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})